import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
  Text,
  useToast,
} from '@chakra-ui/react';
import React from 'react';

import {
  errorToastAdminConfig,
  errorToastId,
  successToastConfig,
} from 'packages/common-frontend/constants';
import {
  GET_CREDIT_AGREEMENT_FULL_ARTIFACT_WIP,
  DOES_CREDIT_AGREEMENT_WIP_EXIST,
} from 'packages/creditAgreements/requests/requests.gql';
import { useRemoveCreditAgreementFullArtifactWipMutation } from 'packages/creditAgreements/requests/requests.gql.generated';

type RemoveCreditAgreementWipModalProps = {
  isOpen: boolean;
  onClose: () => void;
  creditFacilityId: string;
  onSuccess?: () => void;
};
export const RemoveCreditAgreementWipModal = ({
  onClose,
  isOpen,
  creditFacilityId,
  onSuccess,
}: RemoveCreditAgreementWipModalProps) => {
  const toast = useToast();

  const [
    removeCreditAgreementFullArtifactWip,
    { loading: removeCreditAgreementFullArtifactWipLoading },
  ] = useRemoveCreditAgreementFullArtifactWipMutation({
    onCompleted: () => {
      if (!toast.isActive(successToastConfig.id)) {
        successToastConfig.title =
          'Successfully removed credit agreement document wip.';
        toast(successToastConfig);
      }
      onSuccess?.();
    },
    onError: () => {
      if (!toast.isActive(errorToastId)) {
        errorToastAdminConfig.title = `Error removing credit agreement document wip.`;
        toast(errorToastAdminConfig);
      }
    },
    refetchQueries: [
      {
        query: GET_CREDIT_AGREEMENT_FULL_ARTIFACT_WIP,
        variables: { creditFacilityId },
      },
      {
        query: DOES_CREDIT_AGREEMENT_WIP_EXIST,
        variables: { creditFacilityId },
      },
    ],
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent padding="20px">
        <ModalHeader>Confirm WIP Removal</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="8">
            Please confirm credit agreement wip removal. This cannot be undone.
          </Text>
          <Flex justifyContent="space-between">
            <Button
              onClick={() => onClose()}
              marginLeft={3}
              aria-label="Cancel"
            >
              Cancel
            </Button>
            <Button
              isLoading={removeCreditAgreementFullArtifactWipLoading}
              onClick={() => {
                removeCreditAgreementFullArtifactWip({
                  variables: { creditFacilityId },
                });
                onClose();
              }}
              variant="ghost"
              marginLeft={3}
              aria-label="Remove"
            >
              Remove
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
